import Vue from 'vue'
import Vuex from 'vuex'

import cv from './cv'
import cvExperience from './cvExperience'
import jobs from './jobs'
import user from './user'
import cvShare from './cvShare'
import cvIndex from './cvIndex'
import community from './community'
import discuss from "./discuss";
import member from "./member";
import campusOffers from './campusOffers'
import nim from './nim'
import live from './live'

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		cv,
		cvIndex,
		cvExperience,
		jobs,
		cvShare,
		user,
		community,
		discuss,
		member,
		campusOffers,
		nim,
		live
	}
})
